import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { usePocketBase } from '../../PocketBaseContext'; // PocketBaseContext'inizin yolunu doğru şekilde belirtin

//import images
import avatar1 from "../../assets/images/users/user-dummy.jpg";

// Custom hook to fetch user data
const useUserData = () => {
    const pb = usePocketBase();
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            if (pb.authStore.isValid) {
                try {
                    const userId = pb.authStore.model.id;
                    const record = await pb.collection('users').getOne(userId);
                    setUserData(record);
                } catch (error) {
                    console.error("Kullanıcı bilgileri alınamadı:", error);
                }
            }
        };

        fetchUserData();
    }, [pb]);

    return userData;
};

const ProfileDropdown = () => {
    const pb = usePocketBase();
    const userData = useUserData();
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);

    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    if (!userData) {
        return null; // veya bir yükleme göstergesi
    }

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" 
                             src={userData.avatar ? `${pb.baseUrl}/api/files/${userData.collectionId}/${userData.id}/${userData.avatar}` : avatar1}
                             alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userData.name}</span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{userData.role || "Üye"}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Hoş geldiniz {userData.name}!</h6>
                    <DropdownItem className='p-0'>
                        <Link to="/reform-calendar" className="dropdown-item">
                            <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Görev Tahtası</span>
                        </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <Link to="/reform-profile" className="dropdown-item">
                            <span className="badge bg-success-subtle text-success mt-1 float-end">Yeni</span>
                            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Ayarlar</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/auth-lockscreen-basic" className="dropdown-item">
                            <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Ekranı Kilitle</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/logout" className="dropdown-item">
                            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle" data-key="t-logout">Çıkış Yap</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;